// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolId } from './HarvestProtocol';
import { cleaningProcedureId } from './CleaningProcedure';
import { harvestCleaningPositionEnum } from './HarvestCleaningPositionEnum';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { z } from 'zod';
export const harvestProtocolCleaningRequirementId = (z.number());
export const harvestProtocolCleaningRequirement = z.object({
    id: harvestProtocolCleaningRequirementId,
    harvest_protocol_id: harvestProtocolId,
    cleaning_procedure_id: cleaningProcedureId,
    position: harvestCleaningPositionEnum,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    display_order: z.number(),
    equipment_id: equipmentId,
});
export const harvestProtocolCleaningRequirementInitializer = z.object({
    id: harvestProtocolCleaningRequirementId.optional(),
    harvest_protocol_id: harvestProtocolId,
    cleaning_procedure_id: cleaningProcedureId,
    position: harvestCleaningPositionEnum,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    display_order: z.number().optional(),
    equipment_id: equipmentId,
});
export const harvestProtocolCleaningRequirementMutator = z.object({
    id: harvestProtocolCleaningRequirementId.optional(),
    harvest_protocol_id: harvestProtocolId.optional(),
    cleaning_procedure_id: cleaningProcedureId.optional(),
    position: harvestCleaningPositionEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    display_order: z.number().optional(),
    equipment_id: equipmentId.optional(),
});
//# sourceMappingURL=HarvestProtocolCleaningRequirement.js.map